import { Select, MenuItem, Typography, Grid, InputLabel } from "@mui/material";
import FlagIcon from "../../../../global/flag-icon";
import { useEffect, useState } from "react";
import $axios from "../../../../utils/axios";
import axios from "axios";

type Props = {
  onChange?: (selected: Country) => void;
  label?: string;
  multiple: boolean;
  fullWidth?: boolean;
  initial?: number;
  defaultByIP?: boolean;
  showAll?: boolean;
  fullObj?: boolean;
};

interface Country {
  country_name: string;
  country_code: string;
  id: number;
  country_zone: string | null;
}

const CountryPickerDb: React.FC<Props> = ({
  onChange,
  label,
  multiple,
  initial = 1,
  defaultByIP = false,
  showAll = false,
  fullWidth = false,
  fullObj = false,
}: Props) => {
  const initialVal = multiple ? [initial] : initial;
  const [country, setCountry] = useState<any>(initialVal);
  const [countries, setCountries] = useState<Country[]>([]);

  const setByIp = async () => {
    try {
      const ip: axiosIp = await axios.get(
        "https://ipapi.co/json/?access_key=12f091be8f09f428aaa4eb991f300204",
      );
      if (ip && ip.data && ip.data.country_code) {
        const countryIp = countries.filter(
          c => c.country_code === ip.data.country_code,
        );
        if (countryIp&&countryIp.length&&countryIp[0] && countryIp[0].id) {
          setCountry(countryIp[0].id);
          console.log(
            countries.filter(c => c.id == countryIp[0].id)[0],
            countryIp[0].id,
          );
          if (fullObj && onChange)
            onChange(countries.filter(c => c.id == countryIp[0].id)[0]);
        }
        if (countryIp&&countryIp.length&&countryIp[0].country_code === "GB") {
          setCountry(229);
        }
      }
    } catch (e) {
      console.error(e);
      console.log(e);
    }
  };

  const initCountries = async () => {
    const res: any = await $axios.get("auth/generate");
    let newRes: Country[];

    if (showAll) {
      const formatted = res.data.data.map((c: Country) => {
        if (c.id == 0) {
          return {
            id: 0,
            country_code: "All",
            country_name: "All",
            country_zone: null,
          };
        }
        return c;
      });
      newRes = [...formatted].filter((c: any) => c.id != 247);
    } else {
      newRes = [...res.data.data].filter((c: any) => c.id != 247);
    }
    if (fullObj && onChange)
      onChange(newRes.filter(c => c.id == initialVal)[0]);
    setCountries(newRes);
  };

  const getObjSelected: any = (id: number | string) =>
    countries.filter((c: Country) => c.id == id)[0];

  const handleChange = (ev: any) => {
    if (multiple) {
      let v = null;
      if (ev.target.value) {
        v = ev.target.value;
      }
      if (!v) {
        return;
      }
      setCountry(typeof v === "string" ? v.split(",") : v);
    } else {
      setCountry(ev.target.value);
    }
  };
  type axiosIp = {
    data: {
      country_code: string;
    };
  };

  useEffect(() => {
    initCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (onChange) {
      if (fullObj) onChange(countries.filter(c => c.id == country)[0]);
      else onChange(country);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  useEffect(() => {
    if (defaultByIP) {
      setByIp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countries]);

  return (
    <>
      {label && <InputLabel id="labelCountry">{label}</InputLabel>}
      <Select
        multiple={multiple}
        labelId="labelCountry"
        inputProps={{ disableunderline: "true" }}
        value={country}
        variant="standard"
        fullWidth={fullWidth}
        autoWidth={!fullWidth}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: "300px",
            },
          },
        }}
        renderValue={(selected: any) => {
          if (multiple) {
            return (
              <div>
                {selected
                  .map((c: any) => getObjSelected(c)?.country_name)
                  .join(", ")}
              </div>
            );
          } else {
            return (
              <Grid container>
                <FlagIcon code={getObjSelected(selected)?.country_code} />
                <Typography color="text.primary" component="span">
                  {getObjSelected(selected)?.country_name}
                </Typography>
              </Grid>
            );
          }
        }}
        onChange={handleChange}
      >
        {countries.map((countryRow: Country) => (
          <MenuItem key={countryRow.id} value={countryRow.id}>
            <FlagIcon code={countryRow.country_code} />
            {countryRow.country_name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default CountryPickerDb;
